<template>
  <IconLucideBookmark />
</template>
